import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { colors } from '../../../shared/ui/colors'

interface ButtonContainerProps {
  variant: 'primary' | 'secondary' | 'outline'
  size: 'small' | 'medium' | 'large'
  disabled: boolean
}

const variantStyles = {
  primary: css`
    background-color: #3498db;
    color: white;
    border: 1px solid #3498db;

    &:hover:not(:disabled) {
      background-color: #2980b9;
      border-color: #2980b9;
    }
  `,
  secondary: css`
    background-color: #95a5a6;
    color: white;
    border: 1px solid #95a5a6;

    &:hover:not(:disabled) {
      background-color: #7f8c8d;
      border-color: #7f8c8d;
    }
  `,
  outline: css`
    background-color: transparent;
    color: ${colors.orange900};
    border: 1px solid ${colors.orange900};

    &:hover:not(:disabled) {
      background-color: ${colors.orange900};
      color: white;
    }
  `
}

const sizeStyles = {
  small: css`
    padding: 6px 12px;
    font-size: 12px;
  `,
  medium: css`
    padding: 8px 16px;
    font-size: 14px;
  `,
  large: css`
    padding: 12px 24px;
    font-size: 16px;
  `
}

export const ButtonContainer = styled.button<ButtonContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  white-space: nowrap;

  ${({ variant }) => variantStyles[variant]}
  ${({ size }) => sizeStyles[size]}
  
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      cursor: not-allowed;

      &:hover {
        transform: none;
      }
    `}
  
  &:focus {
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.3);
  }
`
